// extracted by mini-css-extract-plugin
export var mt0 = "slide-with-featured-cards-module--mt-0--8eb2b";
export var mt1 = "slide-with-featured-cards-module--mt-1--e1623";
export var mt2 = "slide-with-featured-cards-module--mt-2--ccfbc";
export var mt3 = "slide-with-featured-cards-module--mt-3--fd642";
export var mt4 = "slide-with-featured-cards-module--mt-4--78a4b";
export var mt5 = "slide-with-featured-cards-module--mt-5--3353f";
export var mt6 = "slide-with-featured-cards-module--mt-6--4e7b5";
export var slideWithFeaturedCards = "slide-with-featured-cards-module--slide-with-featured-cards--1ef0c";